(function(){
    'use strict';

    angular.module('tmx-app')
        .directive('tmxKendoSearchbar', [kendoSearchbar]);

    function kendoSearchbar() {

        var directive={
            restrict: 'E',
            scope: {
                kendogrid: '='
            },
            templateUrl: 'common/directives/kendosearchbar/kendosearchbar.html',
            controller: ["$scope",kendoSearchbarCtrl],
       /* controller:function($scope){

        },*/
            controllerAs:'ksbCtrl'
        };
        return directive; 
    }

    function kendoSearchbarCtrl($scope){
        var vm=this;
        vm.scope=$scope;
        vm.searchText="";
        vm.placeholder="Search grid";


        vm.filter=function(){
            var finalFilter=createFilter(vm.scope.kendogrid,"or",vm.searchText);
            vm.scope.kendogrid.dataSource.filter([finalFilter]);
        }
    }

    function createFilter(grid,_logic,searchtext){
        var filter={
            logic:_logic,
            filters:getFilters(grid,searchtext)
        };
        return filter;
    }

    function getFilters(grid,searchtext){
        var filters=[];
      
        grid.columns.forEach(
            function(column,index,array){
                if(column.type==="string"){
                    filters.push(new filter("contains",column.field,searchtext.toString()));
                }
                else if (column.type==="number" && !isNaN(searchtext)){
                    filters.push(new filter("gte",column.field,parseInt(searchtext))); 
                }
            }
        );
        return filters;
    }

    function filter(_operator,_fieldname,_searchtext){
        this.operator=_operator;
        this.field=_fieldname;
        this.value=_searchtext;
    }

    function isColumn(columns,key){
        for(var i=0;i<columns.length;i++){
            if(columns[i].field===key)return true;
        }
        return false;
    }

})();